import React, { useEffect, useState } from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import { homeService, IWebSiteBarType } from './homeService';

export const GatherInfo = () => {
	const [dataSource, setDataSource] = useState<IWebSiteBarType[]>([]);

	useEffect(() => {
		homeService.webSiteStatistics().then(res => {
			res?.retData && setDataSource(res?.retData);
		})
	}, [])

	const option = {
		grid: {
			left: 60,
			right: 40,
			bottom: 110
		},
		//提示框
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
		},
		//图例
		legend: {
			right: 0,
			textStyle: {
				color: "#fff"
			},
			data: ['发布数量', '过滤数量', '识别数量']
		},
		//直角坐标系 grid 中的 x 轴
		xAxis: [
			{
				type: 'category',
				axisTick: { show: false },
				// axisLabel: {
				// 	interval: 0,
				// 	formatter: function (value: string) {
				// 		return value.split("").join("\n");
				// 	}
				// },
				// axisLabel: {
				// 	interval: 0,
				// 	formatter: function (value: string) {
				// 		// debugger
				// 		var ret = "";//拼接加\n返回的类目项  
				// 		var maxLength = 5;//每项显示文字个数  
				// 		var valLength = value.length;//X轴类目项的文字个数  
				// 		var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
				// 		if (rowN > 1)//如果类目项的文字大于3,  
				// 		{
				// 			for (var i = 0; i < rowN; i++) {
				// 				var temp = "";//每次截取的字符串  
				// 				var start = i * maxLength;//开始截取的位置  
				// 				var end = start + maxLength;//结束截取的位置  
				// 				//这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
				// 				temp = value.substring(start, end) + "\n";
				// 				ret += temp; //凭借最终的字符串  
				// 			}
				// 			return ret;
				// 		}
				// 		else {
				// 			return value;
				// 		}
				// 	}
				// },
				// interval: 0,//如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推。
				// rotate: '45',// 刻度标签旋转的角度,在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。
				//坐标轴 线配置
				axisLine: {
					lineStyle: {
						color: "#fff",
						fontSize: "16px"
						// type: [8, 10],
						// dashOffset: 5
					}
				},
				axisLabel: {
					rotate: -45,
				},
				// data: ['中国电建', '中国电建', '中国电建', '中国电建', '中国电建']
				data: dataSource.map(item => item.name)
			}
		],
		//直角坐标系 grid 中的 y 轴
		yAxis: [
			{
				type: 'value',
				axisLine: {
					lineStyle: {
						color: "#CCCCCC",
					}
				},
				//设置网格线颜色
				splitLine: {
					lineStyle: {
						color: ['#143F67'],
						type: [8, 10],
						dashOffset: 5
					}
				},
			}
		],
		//系列  柱子的配置及数据
		series: [
			{
				name: '发布数量',
				type: 'bar',
				barGap: "80%",   //柱子间距
				// label: labelOption,
				barWidth: 10,    //主子宽度
				itemStyle: {
					borderRadius: [5, 5, 0, 0],
					opacity: 0.9,
					color: {
						type: 'linear',
						x: 0.5,
						y: 0.5,
						r: 0.5,
						colorStops: [{
							offset: 0, color: '#1C648B' // 0% 处的颜色
						}, {
							offset: 1, color: '#47DDF5' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				emphasis: {
					focus: 'series'
				},
				data: dataSource.map(item => item.releaseNum)
			},
			{
				name: '过滤数量',
				type: 'bar',
				barGap: "80%",
				// label: labelOption,
				barWidth: 10,
				itemStyle: {
					borderRadius: [5, 5, 0, 0],
					opacity: 0.9,
					color: {
						type: 'linear',
						x: 0.5,
						y: 0.5,
						r: 0.5,
						colorStops: [{
							offset: 0, color: '#1166FF' // 0% 处的颜色
						}, {
							offset: 1, color: '#8906DD' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				emphasis: {
					focus: 'series'
				},
				data: dataSource.map(item => item.filterNum)
			},
			{
				name: '识别数量',
				type: 'bar',
				barGap: "80%",
				// label: labelOption,
				barWidth: 10,
				itemStyle: {
					borderRadius: [5, 5, 0, 0],
					opacity: 0.9,
					color: {
						type: 'linear',
						x: 0.5,
						y: 0.5,
						r: 0.5,
						colorStops: [{
							offset: 0, color: '#0BB4E4' // 0% 处的颜色
						}, {
							offset: 1, color: '#29F49A' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				emphasis: {
					focus: 'series'
				},
				data: dataSource.map(item => item.distinguishNum)
			}
		]
	};
	return (
		<div className="home-content-center-gatherInfo mt-10">
			<div className="home-but-wrapper">
				<span>网站采集数据信息统计</span>
			</div>
			<ReactEchartsCore
				echarts={echarts}
				theme="bar"
				option={option as any}
				style={{ height: "100%" }}
			/>
		</div>
	);
};

